(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){super()}
  connectedCallback(){
    this.header=document.querySelector('.section-header');
    this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always';
    this.headerBounds={};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change',this.setHeaderHeight.bind(this));
    if(this.headerIsAlwaysSticky){this.header.classList.add('shopify-section-header-sticky')}
    this.currentScrollTop=0;
    this.onScrollHandler=this.onScroll.bind(this);
    window.addEventListener('scroll',this.onScrollHandler,false);
    this.createObserver();
  }
  setHeaderHeight(){document.documentElement.style.setProperty('--header-height',this.header.offsetHeight+'px')}
  disconnectedCallback(){window.removeEventListener('scroll',this.onScrollHandler)}
  createObserver(){var self=this;var ob=new IntersectionObserver(function(entries,observer){self.headerBounds=entries[0].intersectionRect;observer.disconnect()});ob.observe(this.header)}
  onScroll(){
    var s=window.pageYOffset||document.documentElement.scrollTop;
    if(s>this.currentScrollTop&&s>this.headerBounds.bottom){this.header.classList.add('scrolled-past-header');requestAnimationFrame(this.hide.bind(this))}
    else if(s<this.currentScrollTop&&s>this.headerBounds.bottom){this.header.classList.add('scrolled-past-header');requestAnimationFrame(this.reveal.bind(this))}
    else if(s<=this.headerBounds.top){this.header.classList.remove('scrolled-past-header');requestAnimationFrame(this.reset.bind(this))}
    this.currentScrollTop=s;
  }
  hide(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky')}
  reveal(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-sticky','animate');this.header.classList.remove('shopify-section-header-hidden')}
  reset(){if(this.headerIsAlwaysSticky)return;this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}
}
customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
